import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { uri } from '../../constants'

const Members = () => {
    const teamId = localStorage.getItem('teamId') // Assuming we store teamId instead of mid
    
    const [members, setMembers] = useState([])
    const [email, setEmail] = useState('')
    const [addBtnText, setAddBtnText] = useState('Submit')
    const [removeBtnText, setRemoveBtnText] = useState('Yes')
    const [removeMemberId, setRemoveMemberId] = useState('')
    const [error, setError] = useState('')
    
    const successBtn = useRef()
    const removeBtn = useRef()

    // Fetch team members
    useEffect(() => {
        fetchMembers()
    }, [])

    const fetchMembers = async () => {
        try {
            const response = await axios.get(`${uri}/teams/${teamId}/members`)
            setMembers(response.data.members.map(member => ({
                id: member.user.user_id,
                firstName: member.user.first_name,
                lastName: member.user.last_name,
                email: member.user.email,
                role: member.role
            })))
        } catch (err) {
            handleError('Failed to fetch team members')
        }
    }

    const handleError = (errorMsg) => {
        setError(errorMsg)
        setTimeout(() => {
            setError('')
        }, 3000)
    }

    const addMember = async (e) => {
        e.preventDefault()
        setAddBtnText('Please Wait...')

        // Check if member already exists
        const addressExistInMembers = members.find(member => member.email === email)
        if (addressExistInMembers) {
            handleError('Member Already Exists')
            setAddBtnText('Submit')
            return
        }

        try {
            await axios.post(`${uri}/teams/${teamId}/members`, {
                email: email
            })
            
            setAddBtnText('Submit')
            successBtn.current.click()
            fetchMembers() // Refresh the members list
            setEmail('') // Clear the email input
        } catch (err) {
            setAddBtnText('Submit')
            handleError(err.response?.data?.error || 'Failed to add member')
        }
    }

    const removeMember = async () => {
        setRemoveBtnText('Please Wait...')
        try {
            await axios.delete(`${uri}/teams/${teamId}/members/${removeMemberId}`)
            setRemoveBtnText('Yes')
            removeBtn.current.click()
            fetchMembers() // Refresh the members list
        } catch (err) {
            setRemoveBtnText('Yes')
            handleError('Failed to remove member')
        }
    }

    return (
        <div className='dash-section'>
            <h1 className='dash-title'>Members</h1>
            <div className="dash-card mt-5">
                <div className="dash-card-heading">
                    <h2 className="dash-card-title">Members</h2>
                    <button 
                        data-bs-toggle="modal"
                        data-bs-target="#addMemberModal"
                        className="dash-card-heading-btn"
                    >
                        <i className="fi fi-sr-plus"></i>
                        Add Member
                    </button>
                </div>
                <div className="table-responsive mt-3">
                    <table className="table dash-table wide-table">
                        <thead>
                            <tr>
                                <td>Name</td>
                                <td>Email</td>
                                <td>Role</td>
                                <td>Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            {members.map((user, i) => (
                                <tr key={i}>
                                    <td>
                                        <div className="table-item">
                                            {user.firstName} {user.lastName}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-item">
                                            {user.email}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-item">
                                            {user.role}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-item d-flex">
                                            <button 
                                                className="table-action-btn a-red me-1"
                                                data-bs-target="#confirmModal"
                                                data-bs-toggle="modal"
                                                onClick={() => setRemoveMemberId(user.id)}
                                            >
                                                <i className="fi fi-rr-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Add Member Modal */}
            <div className="modal fade" id="addMemberModal" tabIndex="-1" aria-labelledby="addMemberModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="addMemberModalLabel">Add Member</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={addMember} className="row">
                                <div className="col-12 mt-3">
                                    <div className="dash-form-group">
                                        <label>Email</label>
                                        <input 
                                            type="email" 
                                            placeholder='Email' 
                                            className='dash-form-input' 
                                            onChange={e => setEmail(e.target.value)}
                                            value={email}
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-12 mt-3">
                                    {error !== '' && <h5 className='text-danger text-center mb-3'>{error}</h5>}
                                    <div className="dash-form-btns">
                                        <button 
                                            type="submit"
                                            className={`dash-form-btn ${addBtnText === 'Please Wait...' && 'disabled'}`}
                                            disabled={addBtnText === 'Please Wait...'}
                                        >{addBtnText}</button>
                                    </div>
                                </div>
                            </form>
                            <button ref={successBtn} data-bs-target="#memberSuccessModal" data-bs-toggle="modal" hidden></button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm Remove Modal */}
            <div className="modal fade" id="confirmModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="confirmModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body success-modal">
                            <Link className='success-close-btn' to="#" data-bs-dismiss="modal">
                                <i className="fi fi-rr-cross"></i>
                            </Link>
                            <h5>Are you sure you want to remove this member?</h5>
                            <div className="d-flex justify-content-center mt-4">
                                <button className="dash-card-heading-btn cancel-btn share-btn me-2" data-bs-dismiss="modal">Cancel</button>
                                <button 
                                    className={`dash-card-heading-btn share-btn ${removeBtnText === 'Please Wait...' && 'disabled'}`} 
                                    onClick={removeMember}
                                    disabled={removeBtnText === 'Please Wait...'}
                                >{removeBtnText}</button>
                                <button ref={removeBtn} data-bs-toggle="modal" data-bs-target="#memberSuccessModal" hidden></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Success Modal */}
            <div className="modal fade" id="memberSuccessModal" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="memberSuccessModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body success-modal">
                            <a className='success-close-btn' href="/dashboard/members">
                                <i className="fi fi-rr-cross"></i>
                            </a>
                            <i className="fi fi-rr-check-circle text-success success-icon"></i>
                            <h5>Members Saved Successfully!</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Members